module.exports = __webpack_public_path__ + "static/media/arrow_right.ca9564f4.svg";